import styled from 'styled-components';

const Heading = styled.h2`
  justify-self: center;
  align-self: center;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 1.75px;
  color: #000000;

  @media (max-width: 414px) {
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.75px;
  }
`;

export default Heading;




